import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Dialog from 'components/dialog'
import { useDialogTitleStyles } from 'components/dialog/use-dialog-title-styles'
import RouterLinkButton from 'components/router-link-button'
import AddIcon from 'components/material-symbol/icons/Add'

const useStyles = makeStyles(theme => ({
  bodyText: {
    margin: 0,
    fontSize: '1rem',
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
  },
}))

const FreeTierLimitDialog = ({ open, setOpen, isPgaHopeCoach }) => {
  const classes = useStyles()
  const titleClasses = useDialogTitleStyles()

  const title = isPgaHopeCoach
    ? 'Create PGA HOPE or Family Golf Event'
    : 'Create Family Golf Event'

  const content = isPgaHopeCoach
    ? 'You have reached your group offering limit on the starter tier. As a certified PGA HOPE coach, you can only create PGA HOPE or Family Golf events. For more event options, consider upgrading to a PGA Coach+.'
    : 'You have reached your group offering limit on the starter tier. You can only create Family Golf events. For more event options, consider upgrading to a PGA Coach+.'

  return (
    <Dialog
      isOpen={open}
      onClose={() => setOpen(false)}
      maxWidth="sm"
      fullWidth
      showCloseButton
      classes={{ paper: titleClasses.dialogPaper }}
    >
      {({ closeDialog }) => (
        <>
          <DialogTitle
            disableTypography
            classes={{ root: titleClasses.titleRoot }}
          >
            <Typography component="h2" className={titleClasses.title}>
              {title}
            </Typography>
            <Typography className={classes.bodyText}>{content}</Typography>
          </DialogTitle>
          <DialogActions className={titleClasses.actions}>
            <Button color="primary" size="large" onClick={closeDialog}>
              Cancel
            </Button>
            <RouterLinkButton
              variant="contained"
              color="primary"
              size="large"
              disableElevation
              startIcon={<AddIcon fontSize="small" />}
              to="/pga-coach/bookings/events/new"
              onClick={closeDialog}
            >
              Create Event
            </RouterLinkButton>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

export default FreeTierLimitDialog
